module.exports.isString = function(value) {
    return typeof value === 'string' || value instanceof String;
}

module.exports.isInteger = function(value) {
    return Number.isInteger(value);
}

module.exports.isFloat = function(value) {
    return typeof value === 'number';
}

module.exports.isArray = function(value) {
    return Array.isArray(value);
}

module.exports.isBoolean = function(value) {
    return typeof value === "boolean"
}